// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1603":"npm.core-js","3773":"npm.dompurify","7383":"npm.html2canvas","8727":"npm.canvg"}[chunkId] || chunkId) + "." + {"1603":"1a65a305bf0a7512cc9c","3773":"5558e016e20178a49e86","4964":"a353f81cffd8a1507d67","7383":"9b044244eeb2ab604613","8727":"e7d3a9e8c0babaa43753"}[chunkId] + ".js";
};